import { useReducer } from 'react';

/**
 * Toggle a boolean value
 *
 * @param {boolean} initialState The initial state of the hook
 * @return {[boolean, () => void]}
 * @example
 * const MyComponent = () => {
 *   const [visible, toggleVisible] = useToggle();
 *   return (
 *     <div>
 *       <button onClick={toggleVisible}>Show/Hide Greeting</button>
 *       {visible && (
 *         <div>Hello, world!</div>
 *       )}
 *     </div>
 *   );
 * }
 */
function useToggle(initialState = false) {
  const [state, toggleState] = useReducer(value => !value, initialState);
  return [state, toggleState];
}

export default useToggle;
